export default "__VITE_ASSET__CQFHyRXK__"